module.exports = __webpack_public_path__ + "img/textured-gradient.b2ba0f11.jpg";